import React, { useState, useRef } from 'react';
import { RxCross2 } from 'react-icons/rx';
import { ConfirmModal } from '../../../../../../common/ui';
import styles from './styles.module.css';

const ProductVariantsTable = ({ rows, removeVariantItem, productType }) => {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const itemRefs = useRef([]);
  const [confirmRemove, setConfirmRemove] = useState({ open: false, variant: null, index: -1 });

  const focusToItem = (index) => {
    setSelectedIndex(index);
    itemRefs.current[index]?.focus();
  };

  const handleRemoveClick = (e, variant, index) => {
    e.stopPropagation();
    setConfirmRemove({ open: true, variant, index });
  };

  const handleConfirmRemove = () => {
    if (confirmRemove.variant != null && removeVariantItem) {
      removeVariantItem(confirmRemove.variant, confirmRemove.index);
    }
    setConfirmRemove({ open: false, variant: null, index: -1 });
  };

  const handleCancelRemove = () => {
    setConfirmRemove({ open: false, variant: null, index: -1 });
  };

  const list = rows ?? [];

  return (
    <div className={styles.tableContainer}>
      <ConfirmModal
        open={confirmRemove.open}
        onClose={handleCancelRemove}
        onConfirm={handleConfirmRemove}
        title="Remove Variant"
        message={`Are you sure you want to remove "${confirmRemove.variant?.variantName ?? ''}" from the variants list?`}
        confirmLabel="Yes"
        cancelLabel="No"
      />
      <div
        className={
          productType === 'NON_STOCK'
            ? styles.tableHeaderNonStock
            : styles.tableHeaderStock
        }
      >
        <div className={styles.cellCode}>Code</div>
        <div className={styles.cellName}>Variant Name</div>
        <div className={styles.cellBarcode}>Barcode</div>
        {productType === 'NON_STOCK' && (
          <>
            <div className={styles.cellNum}>Price</div>
            <div className={styles.cellNum}>Cost</div>
            <div className={styles.cellCenter}>Availability</div>
          </>
        )}
        {productType === 'STOCK' && (
          <div className={styles.cellCenter}>Serial Check</div>
        )}
        <div className={styles.cellRemove} />
      </div>
      <div className={styles.itemContainer}>
        {list.map((item, index) => (
          <div
            key={index}
            className={
              selectedIndex === index ? styles.itemSelected : styles.item
            }
            ref={(el) => (itemRefs.current[index] = el)}
            tabIndex={0}
            onClick={() => focusToItem(index)}
          >
            <div
              className={
                productType === 'NON_STOCK'
                  ? styles.itemGridNonStock
                  : styles.itemGridStock
              }
            >
              <div className={styles.cellCode}>{item.code ?? ''}</div>
              <div className={styles.cellName}>{item.variantName ?? ''}</div>
              <div className={styles.cellBarcode}>{item.barcode ?? ''}</div>
              {productType === 'NON_STOCK' && (
                <>
                  <div className={styles.cellNum}>
                    {typeof item.price === 'number'
                      ? item.price.toFixed(2)
                      : item.price ?? ''}
                  </div>
                  <div className={styles.cellNum}>
                    {typeof item.cost === 'number'
                      ? item.cost.toFixed(2)
                      : item.cost ?? ''}
                  </div>
                  <div className={styles.cellCenter}>
                    {item.availability ? 'Available' : 'Unavailable'}
                  </div>
                </>
              )}
              {productType === 'STOCK' && (
                <div className={styles.cellCenter}>
                  {item.isSerialCheck ? 'Yes' : 'No'}
                </div>
              )}
              <div className={styles.cellRemove}>
                <button
                  type="button"
                  className={styles.removeBtn}
                  onClick={(e) => handleRemoveClick(e, item, index)}
                  aria-label="Remove variant"
                >
                  <RxCross2 size={18} />
                </button>
              </div>
            </div>

            {item.images && item.images.length > 0 && (
              <div className={styles.imageStrip}>
                <span className={styles.imageStripLabel}>Images</span>
                <div className={styles.imageThumbnailRow}>
                  {item.images.map((img, imgIdx) => (
                    <img
                      key={imgIdx}
                      src={img.dataUrl}
                      alt={`Variant image ${imgIdx + 1}`}
                      className={styles.imageThumbnail}
                    />
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductVariantsTable;
